// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ProductLikePill_imageContainer__Re800","thumb":"ProductLikePill_thumb__RHXzx","liked":"ProductLikePill_liked__Kg8q7","like":"ProductLikePill_like__cETbk"};